import { render } from "./Wrapper.vue?vue&type=template&id=35c4b50b&scoped=true&ts=true"
import script from "./Wrapper.vue?vue&type=script&lang=ts"
export * from "./Wrapper.vue?vue&type=script&lang=ts"

import "./Wrapper.vue?vue&type=style&index=0&id=35c4b50b&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c4b50b"]])

export default __exports__